/* unplugin-vue-components disabled */
import {downloadFile} from 'stores/files'
import SourceIcon from './source-icon.vue'
import SourceType from './source-type.vue'

export default {
  components: {SourceIcon, SourceType},
  props: {
    data: {type: Object, required: true},
    disabled: {type: Boolean, default: false},
  },
  emits: ['show', 'hide'],
  computed: {
    type() {
      return this.data.type
    },
    url() {
      return this.data.url
    },
    file_id() {
      return this.data.file_id
    },
    name() {
      return this.data.name
    },
    summary() {
      return this.data.summary || this.data.url
    },
    can_click() {
      return ['url', 'link', 'file'].includes(this.type)
    },
    internal() {
      return this.data.internal
    }
  },
  methods: {
    async onClick(){
      if (this.type === 'url') {
        window.open(this.url, '_blank')
        return
      }
      else if (this.type === 'file' || this.type === 'link') {
        if (this.url) {
          window.open(this.url, '_blank')
          return
        }
        try {
          await downloadFile(this.file_id)
        }
        catch(err) {
          $utils.toasts.error(`Failed to download file ${this.data.name}: ${err}`)
        }
      }
      else if (this.url) {
        window.open(this.url, '_blank')
      }  
    }
  }
}
